import { h } from 'preact';
import { Alert } from '../Alert';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'Alert',
  category: '🪟 Modais & Overlay',
  description: 'Alerta inline com 4 tipos (info, success, warning, error) e título opcional',
  usedIn: ['AgentesPage', 'Profile', 'Integrations'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Alert type="info" title="Informação">Este é um alerta informativo com título.</Alert>
      <Alert type="success">Operação concluída sem erros.</Alert>
      <Alert type="warning" title="Atenção">Seu plano expira em 3 dias.</Alert>
      <Alert type="error">Falha ao conectar com o servidor.</Alert>
    </div>
  ),
};
